import { testimonials } from "@/mocks/testimonials";

const avatarImages: Record<string, string> = {
  "avatar-1": "https://readdy.ai/api/search-image?query=Friendly%20professional%20headshot%20portrait%20of%20a%20young%20woman%20with%20warm%20smile%2C%20natural%20lighting%2C%20clean%20cream%20background%2C%20soft%20expression%2C%20professional%20portrait%20photography%2C%20minimal%20and%20clean&width=200&height=200&seq=avatar-1-v9&orientation=squarish",
  "avatar-2": "https://readdy.ai/api/search-image?query=Friendly%20professional%20headshot%20portrait%20of%20a%20young%20man%20with%20confident%20smile%2C%20natural%20lighting%2C%20clean%20cream%20background%2C%20soft%20expression%2C%20professional%20portrait%20photography%2C%20minimal%20and%20clean&width=200&height=200&seq=avatar-2-v9&orientation=squarish",
  "avatar-3": "https://readdy.ai/api/search-image?query=Friendly%20professional%20headshot%20portrait%20of%20a%20diverse%20young%20woman%20with%20genuine%20smile%2C%20natural%20lighting%2C%20clean%20cream%20background%2C%20soft%20expression%2C%20professional%20portrait%20photography&width=200&height=200&seq=avatar-3-v9&orientation=squarish",
  "avatar-4": "https://readdy.ai/api/search-image?query=Friendly%20professional%20headshot%20portrait%20of%20a%20young%20man%20with%20approachable%20smile%2C%20natural%20lighting%2C%20clean%20cream%20background%2C%20soft%20expression%2C%20professional%20portrait%20photography%2C%20minimal&width=200&height=200&seq=avatar-4-v9&orientation=squarish",
  "avatar-5": "https://readdy.ai/api/search-image?query=Friendly%20professional%20headshot%20portrait%20of%20a%20diverse%20young%20woman%20with%20bright%20smile%2C%20natural%20lighting%2C%20clean%20cream%20background%2C%20soft%20expression%2C%20professional%20portrait%20photography&width=200&height=200&seq=avatar-5-v9&orientation=squarish",
};

const portraitImages: Record<string, string> = {
  "avatar-3": "https://readdy.ai/api/search-image?query=Friendly%20professional%20portrait%20of%20a%20diverse%20young%20woman%20in%20casual%20modern%20clothing%2C%20warm%20natural%20lighting%2C%20clean%20cream%20background%2C%20soft%20and%20approachable%20expression%2C%20professional%20yet%20relaxed%20portrait%20photography%2C%20no%20harsh%20shadows&width=400&height=500&seq=portrait-3-v9&orientation=portrait",
  "avatar-4": "https://readdy.ai/api/search-image?query=Friendly%20professional%20portrait%20of%20a%20young%20man%20in%20casual%20modern%20clothing%2C%20warm%20natural%20lighting%2C%20clean%20cream%20background%2C%20soft%20and%20approachable%20expression%2C%20professional%20yet%20relaxed%20portrait%20photography%2C%20no%20harsh%20shadows&width=400&height=500&seq=portrait-4-v9&orientation=portrait",
};

export default function TestimonialSection() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold text-foreground-800 bg-secondary-100 rounded-full">
            User Reviews
          </span>
          <h2 className="mt-4 text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 tracking-tight">
            What Users Say About ItaobuySpreadsheet
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t) => {
            if (t.type === "image") {
              return (
                <div key={t.id} className="relative h-80 rounded-2xl overflow-hidden group">
                  <img
                    src={portraitImages[t.avatarSeq]}
                    alt={`${t.name} - ItaobuySpreadsheet user review`}
                    title={`${t.name} review | ItaobuySpreadsheet`}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-5">
                    <p className="text-sm text-background-200/90 leading-relaxed line-clamp-4">{t.text}</p>
                    <div className="mt-3">
                      <p className="text-sm font-semibold text-background-50">{t.name}</p>
                      <p className="text-xs text-background-300/80">{t.role}</p>
                    </div>
                  </div>
                </div>
              );
            }
            return (
              <div key={t.id} className="bg-secondary-50 rounded-2xl p-6 flex flex-col">
                <div className="flex items-center gap-3 mb-4">
                  <img
                    src={avatarImages[t.avatarSeq]}
                    alt={`${t.name} avatar`}
                    className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                    loading="lazy"
                  />
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </div>
                <i className="ri-double-quotes-l text-2xl text-secondary-400 mb-3"></i>
                <p className="text-sm text-foreground-700 leading-relaxed flex-1">{t.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}